import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

// Connects to data-controller="sidebar-state"
// Persists sidebar collapse/expand state in a cookie
export default class extends Controller {
  static values = {
    cookieName: { type: String, default: "sidebar_show" }
  }

  connect() {
    this.collapsibles = this.element.querySelectorAll('.card .collapse')
    if (this.collapsibles.length === 0) return

    // Load showing state from cookie
    this.showingIds = this.loadStateFromCookie()

    // Initialize collapse states and set up event listeners
    this.collapsibles.forEach(el => this.setupCollapsible(el))
  }

  loadStateFromCookie() {
    const cookieValue = document.cookie.split('; ').find(row => row.startsWith(this.cookieNameValue + '='))

    if (cookieValue) {
      // Cookie exists, parse the IDs
      return cookieValue.split('=')[1].split('|')
    } else {
      // No cookie, default to showing all
      return Array.from(this.collapsibles).map(c => c.id)
    }
  }

  saveStateToCookie() {
    // Set cookie with path and 1 year expiry
    const maxAge = 60 * 60 * 24 * 365 // 1 year in seconds
    document.cookie = `${this.cookieNameValue}=${this.showingIds.join('|')}; path=/; max-age=${maxAge}`
  }

  setupCollapsible(el) {
    const collapseButton = el.closest('.card').querySelector('[data-bs-toggle=collapse]')
    if (!collapseButton) return

    const icon = collapseButton.querySelector('.bi')

    // If this collapsible is not in the showing list, hide it
    if (!this.showingIds.includes(el.id)) {
      bootstrap.Collapse.getOrCreateInstance(el).hide()
    }

    // Listen for shown event
    el.addEventListener('shown.bs.collapse', (e) => {
      // Update icon
      if (icon) {
        icon.classList.remove('bi-chevron-down')
        icon.classList.add('bi-chevron-up')
      }

      // Add to showing list if not already there
      if (!this.showingIds.includes(el.id)) {
        this.showingIds.push(el.id)
        this.saveStateToCookie()
      }
    })

    // Listen for hidden event
    el.addEventListener('hidden.bs.collapse', (e) => {
      // Update icon
      if (icon) {
        icon.classList.remove('bi-chevron-up')
        icon.classList.add('bi-chevron-down')
      }

      // Remove from showing list
      if (this.showingIds.includes(el.id)) {
        this.showingIds = this.showingIds.filter(id => id !== el.id)
        this.saveStateToCookie()
      }
    })
  }
}
